import React from 'react';
import { TAnnex6V2BackendRecord } from '../../../../../../redux/app/annex6-v2/@types';
import Annex6V2TableRows from './Annex6V2TableRows';
import getSignTableRows from '../_elements_v2/getSignTableRows';
type OwnProps = {
    isSubmitterChiefOrMaster: boolean;
    annex6V2Record: TAnnex6V2BackendRecord;
    theme?: 'light' | 'dark';
};
type Annex6V2RecordParticipantsViewProps = OwnProps;
function Annex6V2RecordParticipantsView(
    props: Annex6V2RecordParticipantsViewProps
) {
    const { annex6V2Record } = props;

    return (
        <Annex6V2TableRows
            record={annex6V2Record}
            tableRows={getSignTableRows(annex6V2Record)}
            theme={props.theme}
        />
    );
}

export default Annex6V2RecordParticipantsView;
